import jsPDF from 'jspdf';
import autotable from 'jspdf-autotable';
import {BasePdf} from './common/base-pdf'
import * as moment from 'moment';
import {bocLogo} from 'src/assets/base64/boc-logo.js'
import { HelperService } from '../helper/helper.service';

export class BookingDetailPdf extends BasePdf {

    constructor(
        private data,
        protected borderMarginOption,
        protected orientation:"p" | "portrait" | "l" | "landscape" = "l",
        protected format = "government-letter",
    ){
        super(borderMarginOption,orientation,format)
    }

    public generate(fileName: any, output_type) {  
        // return
        // this.drawBorder()

        this.generateBookingNumberStatus()
        this.generateMainDetails()
        this.generateItemizedGoodsDesc()

        if(output_type == 'save') {
            this.doc.save(fileName)
            return output_type
        } else {
            return this.doc.output(output_type)            
        }
    }

    private generateBookingNumberStatus() {

        let hasAddedImage = false;

        autotable(
            this.doc,
            {
                columnStyles:{
                    0:{
                        fillColor:[255,255,255]
                    },
                    1:{
                        halign:'right',
                        fillColor:[255,255,255]
                    }
                },
                body: [
                    [
                        {
                            content: "Booking Number: "+this.data.ofw_booking.booking_number
                        },
                        {
                            content: ""
                        }
                    ],
                    [
                        {
                            content: "Status: " +this.data.ofw_booking.status.description
                        },
                        {
                            content: "",
                            styles: {
                                halign: "right"
                            }
                        }
                    ]
                ],
                didDrawCell: (data) => {
                    // console.log(data)
                    if (data.column.index === 1 && data.row.index === 1) {
                        var position = data.cell
                        this.doc.addImage(bocLogo, 'PNG', position.x - 40, position.y - 20, 60, 60)
                    }
                },
                startY:this.borderMargin.top,
                margin:{
                    top: this.borderMargin.top,
                    right: this.borderMargin.right,
                    bottom: this.borderMargin.bottom,
                    left: this.borderMargin.left
                }
            }
        )

        this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 20
    }

    private generateMainDetails() {

        let initialPage = this.doc.getCurrentPageInfo().pageNumber
        let initialYPosition = this.currCoords.y
        let midPoint = this.doc.internal.pageSize.getWidth() / 2

        const standardCellPadding ={left:10,vertical:5,right:5}
        const standardBorder = {top: 0, right: 0, bottom: .2, left: 0}
        const standardBodyStyles = {fillColor:[255,255,255]}
        const standardGlobalStyle = {lineWidth:standardBorder}
        const standardLabelCellWidth = 150

        autotable(
            this.doc,
            {
                styles: standardGlobalStyle,
                headStyles:{
                    fillColor:[255,255,255],
                    textColor: [63,81,181],
                    lineWidth:0
                },
                head:[
                    [
                        {
                            content:'Sender/OFW Details',
                            colSpan:2                            
                        }
                    ]
                ],
                startY:initialYPosition,
                margin:{
                    top: this.borderMargin.top,
                    right: (midPoint + 20),
                    bottom: this.borderMargin.bottom,
                    left: this.borderMargin.left
                }
            }
        )
        
        this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 10
        autotable(
            this.doc,
            {
                styles: standardGlobalStyle,
                bodyStyles : standardBodyStyles as any,
                columnStyles:{
                    0:{
                        cellPadding: standardCellPadding,
                        fillColor:[255,255,255],
                        cellWidth: standardLabelCellWidth
                    },
                    1:{
                        fillColor:[255,255,255]
                    }
                },
                body:[
                    [
                        {content: 'Mode of Shipment'},
                        {content: this.data.ofw_booking.shipment_mode},
                    ],
                    [
                        {content: 'Contact Number/s'},
                        {content: this.data.ofw_booking.pickup_sender_contact_number},
                    ],
                    [
                        {content: 'Address'},
                        {content: this.formatAddress(
                            this.data.ofw_booking.pickup_address,
                            this.data.ofw_booking.pickup_city,
                            this.data.ofw_booking.pickup_state,
                            this.data.ofw_booking.pickup_country,
                            this.data.ofw_booking.pickup_zipcode)
                        }
                    ]
                ],
                startY:this.currCoords.y,
                margin:{
                    top: this.borderMargin.top,
                    right: (midPoint + 20),
                    bottom: this.borderMargin.bottom,
                    left: this.borderMargin.left
                }
            }
        )

        if(this.data.ofw_booking.ask_for_pickup == 1) {
            this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 10
            autotable(
                this.doc,
                {
                    styles: standardGlobalStyle,
                    headStyles:{
                        fillColor:[255,255,255],
                        textColor: 80,
                        cellPadding: standardCellPadding,
                        lineWidth:0
                    },
                    head:[
                        [
                            {
                                content:'Pickup Details',
                                colSpan:2
                            }
                        ]
                    ],
                    bodyStyles : standardBodyStyles as any,
                    columnStyles:{
                        0:{
                            cellPadding: standardCellPadding,
                            fillColor:[255,255,255],
                            cellWidth: standardLabelCellWidth
                        },
                        1:{
                            fillColor:[255,255,255]
                        }
                    },
                    body:[
                        [
                            {content: 'Preferred Date and Time'},
                            { content: this.data.ofw_booking.local_pickup_preferred_date_time }
                            // {content: this.helperService.getDateTimeLocal({date: this.data.ofw_boooking.pickup_preferred_date})}
                        ],
                        [
                            {content: 'Contact Person'},
                            {content: this.data.ofw_booking.pickup_contact_person},
                        ],
                        [
                            {content: 'Contact Number'},
                            {content: this.data.ofw_booking.pickup_contact_number},
                        ],
                    ],
                    startY:this.currCoords.y,
                    margin:{
                        top: this.borderMargin.top,
                        right: (midPoint + 20),
                        bottom: this.borderMargin.bottom,
                        left: this.borderMargin.left
                    }
                }
            )            
        }

        this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 10
            autotable(
                this.doc,
                {
                    styles: standardGlobalStyle,
                    headStyles:{
                        fillColor:[255,255,255],
                        textColor: 80,
                        cellPadding: standardCellPadding,
                        lineWidth:0
                    },
                    head:[
                        [
                            {
                                content:'Consolidator Details',
                                colSpan:2
                            }
                        ]
                    ],
                    bodyStyles : standardBodyStyles as any,
                    columnStyles:{
                        0:{
                            cellPadding: standardCellPadding,
                            fillColor:[255,255,255],
                            cellWidth: standardLabelCellWidth
                        },
                        1:{
                            fillColor:[255,255,255]
                        }
                    },
                    body:[
                        [
                            {content: 'Name'},
                            {content: this.data.ofw_booking.consolidator.description}
                        ],
                        [
                            {content: 'Email Address'},
                            {content: this.data.ofw_booking.consolidator.email_address},
                        ],
                        [
                            {content: 'Complete Address'},
                            {content: this.data.ofw_booking.consolidator.address},
                        ],
                        [
                            {content: 'Contact Number'},
                            {content: this.data.ofw_booking.consolidator.contact_number}
                        ]
                    ],
                    startY:this.currCoords.y,
                    margin:{
                        top: this.borderMargin.top,
                        right: (midPoint + 20),
                        bottom: this.borderMargin.bottom,
                        left: this.borderMargin.left
                    }
                }
            )

        let latestLeftColumnYCoord = (this.doc as any).previousAutoTable.finalY + 10
        let latestLeftColumnPage = this.doc.getCurrentPageInfo().pageNumber

        this.doc.setPage(initialPage)

        autotable(
            this.doc,
            {
                styles: standardGlobalStyle,
                headStyles:{
                    fillColor:[255,255,255],
                    textColor: [63,81,181],
                    lineWidth:0
                },
                head:[
                    [
                        {
                            content:'Recipient Details',
                            colSpan:2                            
                        }
                    ]
                ],
                startY:initialYPosition,
                margin:{
                    top: this.borderMargin.top,
                    right: this.borderMargin.right,
                    bottom: this.borderMargin.bottom,
                    left: (midPoint + 20)
                }
            }
        )
        
        this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 10
        autotable(
            this.doc,
            {
                styles: standardGlobalStyle,
                bodyStyles : standardBodyStyles as any,
                columnStyles:{
                    0:{
                        cellPadding: standardCellPadding,
                        fillColor:[255,255,255],
                        cellWidth: standardLabelCellWidth
                    },
                    1:{
                        fillColor:[255,255,255]
                    }
                },
                body:[
                    [
                        {content: 'Recipient Name'},
                        {content: this.formatName(this.data.ofw_booking.recipient_firstname, this.data.ofw_booking.recipient_middlename, this.data.ofw_booking.recipient_lastname, this.data.ofw_booking.recipient_suffixname)},
                    ],
                    [
                        {content: 'Contact Number/s'},
                        {content: this.data.ofw_booking.recipient_contact_number},
                    ],
                    [
                        {content: 'Email Address'},
                        {content: this.data.ofw_booking.recipient_email_address},
                    ],
                    [
                        {content: 'Complete Address'},
                        {content: this.formatAddress(
                            this.data.ofw_booking.recipient_address,
                            this.data.ofw_booking.recipient_city,
                            this.data.ofw_booking.recipient_state, 
                            "Philippines",
                            this.data.ofw_booking.recipient_zipcode, 
                            this.data.ofw_booking.recipient_barangay,
                        )}
                    ],
                    [
                        {content: 'Relationship to Sender'},
                        {content: this.data.ofw_booking.relationship_to_recipient},
                    ]
                ],
                startY:this.currCoords.y,
                margin:{
                    top: this.borderMargin.top,
                    right: this.borderMargin.right,
                    bottom: this.borderMargin.bottom,
                    left: (midPoint + 20)
                }
            }
        )

        let latestRightColumnYCoord = (this.doc as any).previousAutoTable.finalY + 10
        let latestRightColumnPage = this.doc.getCurrentPageInfo().pageNumber

        if (latestLeftColumnPage > latestRightColumnPage) {
            this.doc.setPage(latestLeftColumnPage)
            this.currCoords.y =  latestLeftColumnYCoord
        }
        else if (latestLeftColumnPage < latestRightColumnPage) {
            this.doc.setPage(latestRightColumnPage)
            this.currCoords.y =  latestRightColumnYCoord
        } else {
            this.currCoords.y = latestLeftColumnYCoord > latestRightColumnYCoord
                ? latestLeftColumnYCoord
                : latestRightColumnYCoord
        }
        this.currCoords.y += 20
    }

    private generateItemizedGoodsDesc() {

        const standardColumnStyles = {fillColor:[255,255,255]}

        autotable(
            this.doc,
            {
                styles:{
                    textColor: 80
                },
                head:[
                    [
                        {
                            content:'Itemized Goods Description',
                            colSpan:7,
                            styles:{
                                textColor: [63,81,181]
                            }
                        }
                    ]
                ],
                headStyles:{
                    fillColor:[255,255,255],
                    textColor: 80
                },
                startY:this.currCoords.y,
                margin:{
                    top: this.borderMargin.top,
                    right: this.borderMargin.right,
                    bottom: this.borderMargin.bottom,
                    left: this.borderMargin.left
                }
            }
        )
        
        this.currCoords.y = (this.doc as any).previousAutoTable.finalY + 10
        autotable(
            this.doc,
            {
                styles:{
                    textColor: 80
                },
                columnStyles:{
                    0:standardColumnStyles as any,
                    1:standardColumnStyles as any,
                    2:standardColumnStyles as any,
                    3:standardColumnStyles as any,
                    4:standardColumnStyles as any,
                    5:standardColumnStyles as any,
                    6:standardColumnStyles as any,
                },
                head:[
                    [
                        {content:'Goods Description'},
                        {content:'Unit of Measure'},
                        {content:'New/Used'},
                        {content:'HS Code'},
                        {content:'Quantity'},
                        {content:'Unit Price (Php)'},
                        {content:'Value (Php)'},
                    ]
                ],
                headStyles:{
                    fillColor:[255,255,255],
                    textColor: 80
                },
                columns: [
                    {dataKey: 'item_description' },
                    {dataKey: 'uom' },
                    {dataKey: 'is_new' },
                    {dataKey: 'hs_code' },
                    {dataKey: 'quantity' },
                    {dataKey: 'unit_price' },
                    {dataKey: 'value_price' },
                ],
                body: [
                    ...this.data.ofw_booking_detail_list,
                    [
                        {
                            content: '',
                            colSpan:7,
                        }
                    ],
                    [
                        {
                            content: '',
                            colSpan:5,
                        },
                        {
                            content: `Total Value (Php)`,
                            styles: {
                                fontStyle: 'bold',
                            }
                        },
                        {
                            content: `${this.data.ofw_booking.total_booking_detail_value}`,
                            styles: {
                                halign: 'left'
                            }
                        }
                    ]
                ],
                startY:this.currCoords.y,
                margin:{
                    top: this.borderMargin.top,
                    right: this.borderMargin.right,
                    bottom: this.borderMargin.bottom,
                    left: this.borderMargin.left
                }
            }
        )

        // autotable(
        //     this.doc,
        //     {
        //         styles:{
        //             textColor: 80
        //         },
        //         columnStyles:{
        //             0:standardColumnStyles as any,
        //             1:standardColumnStyles as any,
        //             2:standardColumnStyles as any,
        //             3:standardColumnStyles as any,
        //             4:standardColumnStyles as any,
        //             5:standardColumnStyles as any,
        //             6:standardColumnStyles as any,
        //         },
        //         head:[
        //             [
        //                 {
        //                     content:'Itemized Goods Description',
        //                     colSpan:7,
        //                     styles:{
        //                         textColor: [63,81,181]
        //                     }
        //                 }
        //             ],
        //             [
        //                 {content:'Goods Description'},
        //                 {content:'Unit of Measure'},
        //                 {content:'New/Used'},
        //                 {content:'HS Code'},
        //                 {content:'Quantity'},
        //                 {content:'Unit Price (Php)'},
        //                 {content:'Value (Php)'},
        //             ]
        //         ],
        //         headStyles:{
        //             fillColor:[255,255,255],
        //             textColor: 80
        //         },
        //         columns: [
        //             {dataKey: 'item_description' },
        //             {dataKey: 'uom' },
        //             {dataKey: 'is_new' },
        //             {dataKey: 'hs_code' },
        //             {dataKey: 'quantity' },
        //             {dataKey: 'unit_price' },
        //             {dataKey: 'value_price' },
        //         ],
        //         body:this.data.ofw_booking_detail_list,
        //         foot:[
        //             [
        //                 {
        //                     content: `Total Value (Php)`,
        //                     colSpan:6,
        //                     styles: {
        //                         fontStyle: 'bold'
        //                     }
        //                 },
        //                 {
        //                     content: `${this.data.ofw_booking.total_booking_detail_value}`,
        //                     colSpan:1
        //                 }
        //             ]
        //         ],
        //         footStyles:{
        //             fillColor:[255,255,255],
        //             textColor: 80,
        //             halign:'right',
        //             fontStyle:'normal'
        //         },
        //         startY:this.currCoords.y,
        //         margin:{
        //             top: this.borderMargin.top,
        //             right: this.borderMargin.right,
        //             bottom: this.borderMargin.bottom,
        //             left: this.borderMargin.left
        //         }
        //     }
        // )
    }

    private formatAddress(address, city, state, country, zip, barangay=null) {
        let formattedAddress = (address ? address + ', ' : '') +
        (barangay ? barangay + ', ' : '') +
        (city ? city + ', ' : '') +
        (state ? state + ', ' : '') +
        (country ? country + ' ': '') +
        (zip ? zip : '') 
        return formattedAddress
      }
    
    private formatName(firstname, middlename, lastname, suffix) {
        let formattedName = firstname + ' ' +
        (middlename ? middlename + ' ' : '') +
        lastname + ' ' +
        (suffix ? suffix  : '')
        return formattedName
      }
}